module.exports = __webpack_public_path__ + "static/img/fun_item2.eba43e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fun_item2.png
// module id = VvAv
// module chunks = 1